import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import getGapAffected from '../../fetches/GapCorrection/getGapAffected';

const GapBanner = () => {
    const [isAffected, setIsAffected] = useState(null);

    useEffect(
        () => {
            const fetchGapData = async() => {
                try {
                    const result = await getGapAffected();
                    const affected = result?.hasAffected === true;
                    setIsAffected(affected);
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(
                        'Error fetching gap data:',
                        error,
                    );
                    setIsAffected(false);
                }
            };
            fetchGapData();
        },
        [],
    );

    if (isAffected === null || !isAffected) {
        return null;
    }

    return (
        <div className={'alert alert-dismissible alert-info'}>
            <div className={'display-flex gap-10'}>
                <span className={'text-color-info text-size-h4 rioglyph rioglyph-info-sign'} />
                <div>
                    <strong className={'text-size-16'}>
                        <FormattedMessage id={'announcement'} defaultMessage={'Announcement'} />
                    </strong>
                    <div className={'margin-y-5'}>
                        <FormattedMessage
                            id={'gap.banner.warning-2'}
                            // eslint-disable-next-line max-len
                            defaultMessage={'Dear Customers, for the downloads that happened after 14th October until 03.12.2025, some data might have been disregarded. They are still available in the tachograph of your vehicles, but haven\'t been downloaded properly. The issue has been fixed and the downloads triggered from now onwards have all the contents. We are currently working on a solution to trigger the downloads on your behalf. If you need the data before our automated solution in place, we kindly ask you to please trigger a manual download for the affected duration.'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GapBanner;
